import { render, staticRenderFns } from "./addCartProduct.vue?vue&type=template&id=5042f6b4&scoped=true"
import script from "./addCartProduct.vue?vue&type=script&lang=js"
export * from "./addCartProduct.vue?vue&type=script&lang=js"
import style0 from "./addCartProduct.vue?vue&type=style&index=0&id=5042f6b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5042f6b4",
  null
  
)

export default component.exports